(function () {
  const SEL = '.free-bottle-selector select';
  const MAX_FETCH_ATTEMPTS = 4;

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async function fetchProductsPage(page) {
    const res = await fetch('/products.json?limit=250&page=' + page);
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const { products } = await res.json();
    return products;
  }

  // Transient network/API failures (Shopify rate limiting, brief outages, etc.)
  // are common enough that a single failed request would otherwise leave the
  // select permanently empty. Retry with backoff before giving up.
  async function fetchProducts() {
    const all = [];
    let page = 1;
    while (true) {
      let products;
      let attempt = 0;
      while (true) {
        try {
          products = await fetchProductsPage(page);
          break;
        } catch (e) {
          attempt++;
          if (attempt >= MAX_FETCH_ATTEMPTS) throw e;
          console.warn('[FBS] Fetch attempt ' + attempt + ' failed for page ' + page + ', retrying:', e);
          await sleep(500 * attempt);
        }
      }
      if (!products.length) break;
      all.push(...products);
      if (products.length < 250) break;
      page++;
    }
    return all.sort((a, b) => a.title.localeCompare(b.title));
  }

  function fill(select, products) {
    select.innerHTML = '';
    const ph = document.createElement('option');
    ph.value = '';
    ph.disabled = true;
    ph.selected = true;
    ph.textContent = 'Choose From List';
    select.appendChild(ph);
    products.forEach(p => select.appendChild(new Option(p.title, p.title)));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    console.log('[FBS] Filled ' + products.length + ' products');
  }

  // PFB dispatches 'change' on the native select when the user picks a value,
  // and may clear/re-render the select's options as part of its internal
  // re-render. Re-fill when that happens — but once the user has actually
  // chosen a product, stop interfering so PFB's display label can update
  // correctly and stay updated.
  function attachGuard(select, products) {
    let busy = false;
    let userHasSelected = false;

    select.addEventListener('change', function () {
      if (select.value) userHasSelected = true;
    });

    const guard = new MutationObserver(function () {
      if (busy || userHasSelected || select.options.length > 1) return;
      busy = true;
      console.log('[FBS] Re-filling after re-render');
      fill(select, products);
      busy = false;
    });
    guard.observe(select, { childList: true });
    return guard;
  }

  async function init() {
    console.log('[FBS] init(), readyState=' + document.readyState);
    let products;
    try {
      products = await fetchProducts();
      console.log('[FBS] Fetched ' + products.length + ' products');
    } catch (e) {
      console.error('[FBS] Fetch failed:', e);
      return;
    }

    let currentSelect = null;
    let currentGuard = null;

    // PFB sometimes swaps the select for a brand-new element while hydrating
    // (rather than just clearing its options in place). A guard attached to
    // the old, now-detached node would never notice the replacement, so keep
    // scanning for the field instead of disconnecting after the first match.
    function setup(select) {
      if (select === currentSelect) return;
      if (currentGuard) currentGuard.disconnect();
      currentSelect = select;
      fill(select, products);
      currentGuard = attachGuard(select, products);
    }

    function scan() {
      const el = document.querySelector(SEL);
      if (el && el !== currentSelect) {
        console.log('[FBS] Select ' + (currentSelect ? 're-mounted, re-filling' : 'found via observer'));
        setup(el);
      }
    }

    scan();
    if (currentSelect) {
      console.log('[FBS] Select found immediately');
    } else {
      console.log('[FBS] Select not in DOM yet — observing...');
    }

    const obs = new MutationObserver(scan);
    obs.observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
